
import {api} from '@/constants'
import {getInTouchForm} from '@/constants'
import BaseInput from "@/components/base/BaseInput.vue";
import BaseCustomTelInput from "@/components/base/BaseCustomTelInput.vue";
import BaseTextArea from "@/components/base/BaseTextArea.vue";
import CongratulationBlock from "@/components/getInTouch/CongratulationBlock.vue";
import {sendAnalyticsEvent} from "@/plugins/helper";

export default {
  components: {
    BaseInput,
    BaseTextArea,
    CongratulationBlock,
    BaseCustomTelInput
  },
  data() {
    return {
      getInTouchForm,
      form: {},
      nameError: false,
      nameErrorMessage: '',
      errors: {},
      errorMessage: {},
      isFilled: false,
      hasError: false,
      isValidNumber: false,
    }
  },
  watch: {
    'form.name': function(value) {
      this.checkName()
    },
  },
  methods: {
    async sendContact() {
      this.checkName()
      this.checkNumberOrEmail()

      if (!this.nameError && !this.hasError ) {
        if(this.form.phoneNumber && !this.isValidNumber) return
        this.form.name =  this.form.name.trim()

        await sendAnalyticsEvent("submit_click", {
          "device_time": Math.round(Date.now() / 1000),
          "name": this.form.name,
          "email": this.form.email,
          "phoneNumber": this.form.phoneNumber
        })
        await this.$axios.$post(api.PARTNERS_API +'/web/partner?form=us', this.form, {
          headers: {
            'content-type': 'application/json'
          }
        }).then((res) => {
          if (res.status === 'OK') this.isFilled = true
        }).catch(error => {
          throw new Error(error)
        })
      }
    },
    checkName() {
      let length = this.form.name ?  this.form.name.trim().length : 0
      if (!this.form.name || !length) {
        this.nameError = true
        this.nameErrorMessage = "Please fill your name field"
        this.$refs.name[0].$el.lastChild.classList.add('error')
      } else {
        this.nameError = false
        this.nameErrorMessage = ''
        this.$refs.name[0].$el.lastChild.classList.remove('error');
      }
    },
    checkNumberOrEmail() {
      if (!this.form.email && !this.form.phoneNumber) {
        this.$refs.email[0].$refs.email.classList.add('error')
        this.$refs.phoneNumber[0].$refs.phoneContainer.lastChild.lastChild.classList.add('error')
        this.hasError = true
      } else {
        this.$refs.email[0].$refs.email.classList.remove('error')
        this.$refs.phoneNumber[0].$refs.phoneContainer.lastChild.lastChild.classList.remove('error')
        this.hasError = false
      }
    },
    handleValidNumber(isValid) {
      this.isValidNumber = isValid
    },
    removeError(data) {
      delete this.errors[data]
    }
  }
}
